<lx-editor width="100%" [value]="value" (onChange)="onChange.emit($event)" [autofocus]="true"></lx-editor>
